<template>
  <div id="app">
<!--       <button style="display:inline-block" @click="clickSome()">客服</button>-->
      <div
        ref="floatButton"
        class="float_info"
        :style="{'left': left + 'px', 'top': top + 'px'}"
        v-show="showKefu"
      >
        <img style="display:inline-block;object-fit: none;height:56px" src="../../assets/kefu_new.png" @click="clickSome()" />
      </div>
      <div style="height:100%">
        <iframe  frameborder="0" :src="src"></iframe>
      </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'app',
  data () {
    return {
      showKefu:false,
      src: '',
      clientWidth: 0,
      clientHeight: 0,
      timer: null,
      currentTop: 0,
      left: document.documentElement.clientWidth - 120,
      top: document.documentElement.clientHeight - 185,

    }
  },
  mounted(){
    this.src = this.$route.query.url;
    this.checkTimeIsWork();
    this.$nextTick(() => {
            const floatButton = this.$refs.floatButton
            floatButton.addEventListener("touchstart", () => {
                floatButton.style.transition = 'none'
            })
            // 在拖拽的过程中，组件应该跟随手指的移动而移动。
            floatButton.addEventListener("touchmove", (e) => {
                // console.log('移动中', e)
                if (e.targetTouches.length === 1) {         // 一根手指
                    let touch = e.targetTouches[0]
                    this.left = touch.clientX - 120;
                    this.top = touch.clientY-40
                }
            })
			      // 拖拽结束以后，重新调整组件的位置并重新设置过度动画。
            floatButton.addEventListener("touchend", () => {
                floatButton.style.transition = 'all 0.3s'
                if(this.top<0){
                  this.top =0
                }
                if(this.top>document.documentElement.clientHeight-85){
                  this.top = document.documentElement.clientHeight - 185
                }

                this.left = document.documentElement.clientWidth - 120

                // if(this.left > document.documentElement.clientWidth / 2) {
                //     this.left = document.documentElement.clientWidth - 60
                // }else{
                //     this.left = 5
                // }
            })
        });

  },
  methods:{
    checkTimeIsWork(){
      let _this = this;
      let url = 'https://jd-service-ssl.jdponline.cn/plat-resource/conf/checkDateIsWork';
      fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(response => {
          console.log(response)
          if(response.success && response.result){
            _this.showKefu=true;
          }

        })
    },
    clickSome(){
      wx.miniProgram.redirectTo({
        url:'/pages/research/customerService/customerService?url='+encodeURIComponent(this.src),
          success: function(){
            console.log('success')
          },
          fail: function(){
            console.log('跳转回小程序的页面fail');
          },
      });
    }
  }
}
</script>

<style>
  #app{
    text-align: center;
  }
  .float_info{
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
        /*color: #666666;*/
        transition: all 0.3s;
        position: fixed;
        /* bottom: 50px;
        right: 5px; */
        width: 122px;
        height: 56px;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        z-index: 999;
        /*background: #fff;*/
        border-radius: 56px 0 0 56px;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// src/page/Home/Home.vue